import { ConsentUpdate, ConsentUpdateList, Purpose } from '@mfec/types/model';

import HttpClient from './HttpClient';

export interface ErrorResponse {
  statusCode: number; // The HTTP status code.
  error: string; // A general error name, e.g., Bad Request.
  message: string; // A more detailled error message.
}

export interface Api4pClientOptions {
  apiUrl: string;
  altFetchMethodName?: string;
  accessToken?: string;
  traceid?: string;
}

export default class Api4pClient {
  httpClient: HttpClient;

  public constructor({
    apiUrl, altFetchMethodName, accessToken, traceid,
  } : Api4pClientOptions) {
    this.httpClient = new HttpClient({
      apiUrl,
      accessToken,
      altFetchMethodName,
      traceid,
    });
  }

  public async getConsents(spId?: string, lcId?: string): Promise<Purpose[]> {
    const path = '/services/mfe/consents';

    let query = {};
    if (spId && lcId) {
      query = { lcId, spId };
    }

    return this.httpClient.get<Purpose[], ErrorResponse>(path, query);
  }

  public async postConsentsUpdateList(tenant: string, consents: ConsentUpdate[], spId?: string, lcId?: string) {
    const path = '/services/mfe/consents';
    const headers = {
      'x-tenant': tenant,
    };

    let query = {};
    if (spId && lcId) {
      query = { lcId, spId };
    }

    return this.httpClient.post<ConsentUpdateList, ErrorResponse>(path, { consents }, query, headers);
  }
}
